// extracted by mini-css-extract-plugin
export default {"star_com":"index_star_com__XhaoL","star_item":"index_star_item__MiCIj"};